import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/** Full-page progress before any shell exists (FEED-001); the text names the state (A11Y-006). */
export function LoadingScreen({ message }: { message: string }) {
  return (
    <Container component="main" maxWidth="sm" sx={{ py: 8 }}>
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <CircularProgress aria-hidden="true" />
        <Typography variant="body1" role="status">
          {message}
        </Typography>
      </Stack>
    </Container>
  );
}
